import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { fetchAndSaveUserDetails } from "../services/ApiService";
import { useAuth } from "../context/AuthContext";
import styled, { keyframes } from "styled-components";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

// Preserve current protocol + host (tenant + env)
function redirectTo(path) {
    const { origin } = window.location;
    window.location.href = `${origin}${path}`;
}

const BankIdComplete = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const query = useQuery();
    const orderRef = query.get("orderRef");

    useEffect(() => {
        if (!orderRef) {
            console.error("No BankID orderRef found in URL!");
            return;
        }

        console.log("[BankID Complete] Starting polling...");

        let attempts = 0;
        const maxAttempts = 60;

        const intervalId = setInterval(async () => {
            attempts++;

            try {
                const response = await fetch(`https://boxmealadminapinew.azurewebsites.net/BankId/collect`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ orderRef }),
                });

                const data = await response.json();
                console.log("[BankID Complete] Polling result: ", data);

                if (data.status === "complete") {
                    clearInterval(intervalId);

                    const personalNumber = data.completionData.user.personalNumber;
                    console.log("Personal number received:", personalNumber);

                    const loginResponse = await fetch(`https://boxmealadminapinew.azurewebsites.net/api/auth/login-or-register`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "User-Agent": "BoxmealAdmin/1.0 (+https://handla.ziplink.se)",
                        },
                        body: JSON.stringify({ personalNumber }),
                    });

                    const loginData = await loginResponse.json();

                    if (!loginResponse.ok) {
                        if (loginData.message === "User does not exist. Please register.") {
                            // relative path keeps current origin
                            window.location.href = "/registration";
                            return;
                        } else {
                            console.error("Unexpected login error:", loginData);
                            return;
                        }
                    }

                    localStorage.setItem("authToken", loginData.token);
                    localStorage.setItem("customerId", loginData.customerId);

                    const userDetails = await fetchAndSaveUserDetails(loginData.token);
                    if (userDetails) {
                        login(userDetails, loginData.token);
                        // Keep the same host (tenant) and go to products
                        redirectTo("/products");
                    } else {
                        console.error("Failed to fetch user details.");
                    }

                } else if (data.status !== "pending" || attempts > maxAttempts) {
                    clearInterval(intervalId);
                    console.error("Polling failed or timed out.");
                }
            } catch (error) {
                console.error("Polling error:", error);
                clearInterval(intervalId);
            }
        }, 1000);

        return () => clearInterval(intervalId);
    }, [orderRef, navigate, login]);

    return (
        <Container>
            <Content>
                <Heading>
                    Slutför autentisering...
                    <Spinner />
                </Heading>
                <SubText>Vänligen vänta</SubText>
            </Content>
        </Container>
    );
};

export default BankIdComplete;

const Container = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000; /* Dark background */
`;

const Content = styled.div`
  text-align: center;
`;

const Heading = styled.h2`
  font-size: 28px;
  color: #fff; /* White text */
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SubText = styled.p`
  font-size: 18px;
  color: #ccc; /* Slightly lighter text */
`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  width: 20px;
  height: 20px;
  border: 3px solid #fff;
  border-top: 3px solid #555;
  border-radius: 50%;
  margin-left: 10px;
  animation: ${spin} 1s linear infinite;
`;
